/* eslint-disable react/prop-types */
import {useState} from 'react';
import Locale from '../util/Locale';
import './RenameFolder.scss';
import LoadingIndicator from './LoadingIndicator';

function RenameFolder({title, name, setShowModal, onAction}) {
    const [isLoading, setIsLoading] = useState(false);
    const [nameValue, setNameValue] = useState(name || '');
    const [nameError, setNameError] = useState(nameValue.length ? null : Locale.getText('RENAME_FOLDER_NOT_EMPTY'));
    const [status, setStatus] = useState(null);

    const onInput = event => {
        const newName = event.target.value.trim();
        setNameValue(newName);
        setNameError(newName.length ? '' : Locale.getText('RENAME_FOLDER_NOT_EMPTY'));
    };

    const renderResult = () => {
        if (status !== null) {
            if (status === true) {
                return <div className="status alt-description">{Locale.getText('FOLDER_NAME_UPDATED')}</div>;
            }
            return <div className="status alt-description">{Locale.getText('FOLDER_NAME_NOT_UPDATED')}</div>;
        }
        return null;
    };

    const renderFooter = () => {
        return (
            <div className="rename-actions">
                {status === null && (
                    <nsemble-button text onClick={() => setShowModal && setShowModal(false)}>
                        {Locale.getText('CANCEL')}
                    </nsemble-button>
                )}
                {status === null && (
                    <LoadingIndicator isLoading={isLoading}>
                        <nsemble-button
                            text
                            disabled={nameError ? true : undefined}
                            onClick={async () => {
                                if (onAction && nameValue) {
                                    setIsLoading(true);
                                    const actionStatus = await onAction(nameValue);
                                    setStatus(actionStatus);
                                    setIsLoading(false);
                                }
                            }}
                        >
                            {Locale.getText('RENAME_FOLDER')}
                        </nsemble-button>
                    </LoadingIndicator>
                )}
                {status !== null && (
                    <nsemble-button text onClick={() => setShowModal && setShowModal(false)}>
                        {Locale.getText('CLOSE')}
                    </nsemble-button>
                )}
            </div>
        );
    };

    if (name === undefined) {
        return null;
    }

    return (
        <div>
            <div id="modal-header">
                <h1>{title}</h1>
            </div>
            <div id="modal-body">
                <div className="rename-folder">
                    <div className="rename-section">
                        <span className="rename-title">{Locale.getText('FOLDER_NAME')}</span>
                        <nsemble-input
                            name="name"
                            disabled={status === null ? undefined : true}
                            error={nameError}
                            onInput={onInput}
                            value={nameValue}
                        />
                    </div>
                    {renderResult()}
                </div>
            </div>
            <div id="modal-footer">{renderFooter()}</div>
        </div>
    );
}

export default RenameFolder;
